import { ScorecardListItem } from 'store/interfaces';
import getCurrentReviewCycleId from './getCurrentReviewCycleId';

const sortByMostRecentScorecard = (
  a: ScorecardListItem,
  b: ScorecardListItem,
) =>
  (b.lastUpdatedAt ?? '').localeCompare(a.lastUpdatedAt ?? '') || b.id - a.id;

/**
 * Groups all scorecards from the current review cycle into the "current"
 * bucket. Falls back to the latest cycle by `endAt` desc when nothing
 * contains today.
 */
const splitByCycle = (items: ScorecardListItem[]) => {
  if (items.length === 0) return { current: [], past: [] };
  const currentCycleId = getCurrentReviewCycleId(
    items
      .map((item) => item.reviewCycle)
      .filter((reviewCycle): reviewCycle is NonNullable<typeof reviewCycle> =>
        Boolean(reviewCycle),
      ),
  );
  const sortedByEndDesc = [...items].sort((a, b) =>
    (b.reviewCycle?.endAt ?? '').localeCompare(a.reviewCycle?.endAt ?? ''),
  );

  if (typeof currentCycleId !== 'number') {
    return { current: [], past: sortedByEndDesc };
  }

  const current = items
    .filter((item) => item.reviewCycle.id === currentCycleId)
    .sort(sortByMostRecentScorecard);
  const past = sortedByEndDesc.filter(
    (item) => item.reviewCycle.id !== currentCycleId,
  );
  return { current, past };
};

export default splitByCycle;
